module.exports = __webpack_public_path__ + "static/img/custom-design.5ca3bf3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/custom-design.jpg
// module id = J+Ju
// module chunks = 1